var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"tag-list"},_vm._l((_vm.value),function(tag){return _c('li',{key:tag,staticClass:"tag-list-item"},[_c('span',[_vm._v(_vm._s(_vm.getLabelCallback ? _vm.getLabelCallback(tag) : tag))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }